export const maskEmail = (email: string) => {
    const [name, domain] = email.split('@');
    const newName = [...name].map((l, i) => (name.length - 4 < i ? '*' : l)).join('');

    return `${newName}@${domain}`;
};
